import React,{useState,useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import { Button,Table,Container,Row,Col,Form } from 'react-bootstrap';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';


function Master_Country_List(){  
    const navigate = useNavigate();
    const [isMsgBox,setMsgBox] = useState(false); 
    const [msgText,setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [countryData, setCountryData] = useState([]);
    const [showAddEditForm,setAddEditFormShow] = useState(false);
    const [showAddNewBtn,setShowAddNewBtn] = useState(true);

    const [srNo,setSrNo] = useState(0);
    const [country,setCountry] = useState("");
    const [nationality,setNationality] = useState("");
    const [swiftCode,setSwiftCode] = useState("");
    
    const [status,setStatus] = useState(0);
    const [ddActiveOptions,setDdActiveOptions] = useState([]);

    const [fatf,setFatf] = useState(0);
    const [ddFatfOptions,setDdFatfOptions] = useState([]);

    const [userRight,setUserRight] = useState([]);
    
    useEffect(()=>{
        if(onceRun){
            return;
        }else{
            
            setDdActiveOptions([{name:'Active',value:"1"},{name:'Inactive',value:"0"}]);
            setDdFatfOptions([{name:'YES',value:'1'},{name:'No',value:'0'}]);
            Common.callApi(Common.apiCountry,[sid,'listjson'],function(result){ 
                setCountryData(JSON.parse(result));
            });
            Common.callApi(Common.apiRight,[sid,'all','COUNTRY'],function(result){
                let resp = JSON.parse(result);
                if(resp.query==="1"){
                    setUserRight(resp);
                }else{
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    },[onceRun,sid,navigate]);

    function getList(){
        
        Common.callApi(Common.apiCountry,[sid,'listjson'],function(result){ 
            setCountryData(JSON.parse(result));          
        });
    }

    function addNew(){
        setSrNo(0);
        setCountry("");
        setNationality("");
        setSwiftCode("");
        setFatf(0);
        setStatus(1);
        
        setAddEditFormShow(true);
        setShowAddNewBtn(false);
    }

    function saveData(){
        if(country==="" || nationality==="" || swiftCode==="" || fatf==="" || status===""){
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            var object1 = {
                srno: srNo,
                cnt: country,
                act: status,
                cls: 1,
                nat: nationality,
                swtcd: swiftCode,
                fatf: fatf
            };
            Common.callApi(Common.apiCountry,[sid,'save',srNo,JSON.stringify(object1)],function(result){ 
                let resp = JSON.parse(result);
                if(resp.err===""){
                    setAddEditFormShow(false);
                    setShowAddNewBtn(true);
                    
                    getList();
                }else{
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        }
    }

    function cancelData(){
        setAddEditFormShow(false);
        setShowAddNewBtn(true);
    }

    function fillEditForm(id){
        Common.callApi(Common.apiCountry,[sid,'detail',id],function(result){ 
            let resp = JSON.parse(result);
            setSrNo(resp.srno);
            setCountry(resp.country);
            setNationality(resp.natlty);
            setSwiftCode(resp.swift);
            setFatf(resp.fatf);
            setStatus(resp.active);
            
            /* cclass           */
            setAddEditFormShow(true);
            setShowAddNewBtn(false); 
        });
    }
    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
                <Container fluid >
                    <Row>
                        <Col>
                            <h1>Country Master</h1>
                        </Col>  
                    </Row>
                    {showAddNewBtn?
                        <Row>
                            <Col>
                            {userRight.add==="1"?
                                <Button  variant="outline-primary" size="sm"  onClick={addNew}>Add New</Button>
                                :null
                            }
                                
                            </Col>
                        </Row>
                    :null
                    }

                    <Row><Col>&nbsp;</Col></Row>
                    {showAddEditForm?
                    <Row>
                        <Col className="divContentCenter">
                             {/*Add Edit Form  className="mb-3" className="divContentCenter" */  }
                                <div className="maxFormWidth">
                                    <Form>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Serial Number</Form.Label>
                                                    <Form.Control type="text" placeholder="Serial Number" value={srNo} disabled />
                                                </Form.Group>                                        
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Country<span className="mandatory">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Country" maxLength={50}
                                                    value={country} onChange={(e)=>setCountry(e.target.value)}  autoComplete="off"/>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Nationality<span className="mandatory">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Nationality" maxLength={50}
                                                     value={nationality} onChange={(e)=>setNationality(e.target.value)} autoComplete="off" />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Swift Code<span className="mandatory">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Swift Code" maxLength={10} 
                                                    value={swiftCode} onChange={(e)=>setSwiftCode(e.target.value)}  autoComplete="off" />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>FATF</Form.Label>
                                                    <Form.Select 
                                                        value={fatf}
                                                        onChange={(e)=>setFatf(e.target.value)}
                                                    >
                                                    {ddFatfOptions.map((res)=>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Status</Form.Label>
                                                    <Form.Select 
                                                        value={status}
                                                        onChange={(e)=>setStatus(e.target.value)}
                                                        >
                                                        {ddActiveOptions.map((res)=>
                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>&nbsp;</Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Button  variant="outline-success" size="sm"  onClick={()=>saveData()}>Save</Button>&nbsp;
                                                <Button  variant="outline-danger" size="sm"  onClick={()=>cancelData()}>Cancel</Button>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>&nbsp;</Col>
                                        </Row>
                                    </Form>
                                </div>
                        </Col>
                    </Row>
                    :
                        <Row>
                            <Col >
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            {userRight.edit==="1"? <th></th> :null}
                                            <th className="textRight">Sr No</th>
                                            <th >Country</th>
                                            <th >Nationality</th>
                                            <th >Swift Code</th>
                                            <th >FATF</th>
                                            <th >Status</th>
                                        </tr>
                                    </thead>
                                    <tbody id="tblBody">
                                    {countryData.map((res) => 
                                        <tr key={res.cnt_srno}>
                                            {userRight.edit==="1"?
                                                <td className="textCenter" >
                                                    <span className="handCursor" onClick={()=>fillEditForm(res.cnt_srno) } >
                                                        <div className="colorThemeBlue"><FontAwesomeIcon icon={faEdit}  /></div>
                                                    </span>
                                                </td>
                                            :null
                                            }
                                            <td className="textRight">{res.cnt_srno}</td>
                                            <td>{res.cnt_name}</td>
                                            <td>{res.cnt_nationality}</td>
                                            <td>{res.cnt_swiftcode}</td>
                                            <td>{res.cnt_fatf}</td>
                                            <td>{res.cnt_active}</td>
                                        </tr>
                                    )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    }
                </Container>
                <div>
                    <Dialog isOpen={isMsgBox} onClose={(e)=> setMsgBox(false) }>
                        {msgText}
                    </Dialog>
                </div>
        </>
    );
}
export default Master_Country_List;